module.exports = function getResource(label) {
    const resources = {
        gotIt: 'OK',
        undo: 'Annuler'
    };

    return resources[label];
};
